import React, { useState } from "react";
import "./CallForPapersSection.css";

export default function CallForPapersSection() {
   const [showAll, setShowAll] = useState(false);

 const papers = [
  {
    title: "AI-Driven Routing in Computer Networks",
    desc: "This collection focuses on intelligent routing algorithms, traffic optimization, SDN and NFV-based network management, and advanced internet architectures using AI and ML.",
    deadline: "30 June 2025",
  },
  {
    title: "5G & Massive MIMO for Next-Gen Wireless Connectivity",
    desc: "Research on massive MIMO antenna design, beamforming, spectrum efficiency, and low-latency communication for smart cities and IoT applications.",
    deadline: "31 July 2025",
  },
  {
    title: "Network Security for Future Internet Systems",
    desc: "Papers focusing on intrusion detection, secure routing, blockchain-based networking, zero-trust architectures, and emerging threats to modern networks.",
    deadline: "31 August 2025",
  },
  {
    title: "Advances in Optical & Underwater Optical Communication",
    desc: "Topics include underwater wireless optical communication (UWOC), laser-based data transmission, FSO systems, and photonic device innovations.",
    deadline: "30 September 2025",
  },
  {
    title: "Wireless Communication for Smart Mobility",
    desc: "Covers low-power wireless systems, IoT communication, UAV networking, broadband access in rural areas, and satellite-integrated networks.",
    deadline: "31 October 2025",
  },
  {
    title: "Future Trends in Cryptographic Systems",
    desc: "This includes post-quantum cryptography, lightweight cryptographic methods for IoT devices, encryption in cloud services, and secure blockchain development.",
    deadline: "30 November 2025",
  },
  {
    title: "Cloud Computing & Distributed Systems Innovation",
    desc: "Papers on serverless architectures, virtualization, distributed storage, high-performance cloud infrastructure, and scalable computing models.",
    deadline: "31 December 2025",
  },
  {
    title: "Mobile Ad-Hoc Networks & IoT Connectivity",
    desc: "Research involving opportunistic networks, cluster-based routing, self-healing MANETs, and secure IoT deployments.",
    deadline: "15 October 2025",
  },
  {
    title: "Vehicular Ad-Hoc Networks for Intelligent Transport",
    desc: "Topics include V2X communication, autonomous vehicle networking, VANET security, and congestion-free vehicular data routing.",
    deadline: "15 December 2025",
  },
  {
    title: "Cyber Security in the Era of AI",
    desc: "Focused on digital forensics, AI-enabled defense, malware detection, cyber-crime prevention, and privacy-preserving technologies.",
    deadline: "31 May 2025",
  },
  {
    title: "Communication Systems & Signal Processing",
    desc: "Subjects cover modulation techniques, adaptive filtering, channel coding, and next-generation RF communication system designs.",
    deadline: "30 April 2025",
  },
  {
    title: "Emerging Innovations in Communication & Computer Engineering",
    desc: "Interdisciplinary work blending wireless systems, embedded solutions, edge intelligence, and hardware-accelerated computing.",
    deadline: "31 August 2025",
  },
  {
    title: "Computer Science & Engineering Research Frontier",
    desc: "Papers focusing on algorithms, software engineering, distributed systems, AI-driven computation models, and robotics applications.",
    deadline: "31 October 2025",
  },
];

 const visiblePapers = showAll ? papers : papers.slice(0, 3);

  return (
    <section className="cfp-sec-section" id="call-for-papers">
      <div className="cfp-sec-header">
        <h2 className="cfp-sec-title">Call for Papers</h2>
        <p className="cfp-sec-subtitle">
          <a href="#" className="cfp-sec-login-link">
            Log in
          </a>{" "}
          for personalised recommendations.
        </p>
      </div>

      <div className="cfp-sec-cards-container">
        {visiblePapers.map((paper, index) => (
          <div key={index} className="cfp-sec-card">
            <p className="cfp-sec-card-tag">Collection</p>
            <h3 className="cfp-sec-card-title">{paper.title}</h3>
            <p className="cfp-sec-card-desc">{paper.desc}</p>
            <div className="cfp-sec-card-footer">
              <p className="cfp-sec-deadline-label">Submission deadline</p>
              <p className="cfp-sec-deadline-date">{paper.deadline}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="cfp-sec-footer-btn">
        <button
          className="cfp-sec-view-all-btn"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "See less ←" : "See all calls for papers →"}
        </button>
      </div>
    </section>
  );
}
